import axiosInstance from 'api/base';
import { normalizeRedirectLink } from 'utils/commonNormalizer';
import { prepareFormData } from 'utils/form';

import { IManualPayoutForm, IManualPayoutResponse } from './types';

const manualPayoutApi = {
  async createManualPayout(payload: IManualPayoutForm): Promise<IManualPayoutResponse> {
    const normalizedPayload = prepareFormData(payload);

    const response = await axiosInstance.post('payouts', normalizedPayload);

    return normalizeRedirectLink(response.data);
  },
};

export default manualPayoutApi;
